import React from 'react';
import QuoteRequestForm, { BrochureBtn, VideoButton, ImgRender } from '../BFComponents';

const Navigator = () => {
    return (
        <div className="container">
            <div id="navigator-banner-div">
                <ImgRender
                    image={"navigator-page-banner.jpg"}
                    width={100}
                    sm={true}
                />
            </div>
            <div>
                <h1 className="red" id="navigator-reasons">Reasons to buy Navigator</h1>
            When you choose Navigator over an everyday paper, you are reducing your total
costs. By using our premium paper, you can save time and money while getting
excellent printing results. <strong>Pure Logic</strong>.
        </div >
            <div className="row" id="navigator-details">
                <div className="col-md-6"><strong className="red">Increased productivity.</strong> 99.99% paper jam-free.
                Fewer jams means lower cost per printed document.<br />
                    <strong className="red">Improved surface.</strong> Provides excellent printing quality whilst reducing
                toner consumption.<br />
                    <strong className="red">Silky touch.</strong> Extra smooth surface. Navigator improves
                the lifetime of office equipment.<br />
                    <strong className="red">Multifunctional.</strong> 100% guaranteed for all printers and
copiers. Navigator can be used for all your documents.<br /><br />
                    <strong className="blue">Increased productivity per day</strong><br />
                    The certified performance of Navigator means that it jams once every 10,000
                    sheets, as opposed to 5 jams of other office papers. Taking into consideration that a paper jam can take up to 3 minutes to solve, depending on the type of printing equipment of photocopier used, this can translate in a potential gain in productivity. <br /><br />
                    Optimal balance between paper rigidity and thickness to provide outstanding
                    performance: 99.99% jam free. A reduction in jams means an increase in
                    production speed and fewer processing errors.  <br /><br /><strong className="blue">Paper abrasiveness and
                    lifetime of office equipment</strong><br />
                    Navigator is on average 1/3 smoother than most office papers.
                    This smoother surface means lower toner/ink consumption and
                    reduced abrasiveness, resulting in less damage to printers and
                    a longer lifetime of office equipment.
                    The net result is lower maintenance costs (fewer replacements
                    of machine parts) and ultimately, a lower cost per printed page.
</div>

                <div className="col-md-6">
                    <QuoteRequestForm source={window.location} />
                    <BrochureBtn brochure={"navigator-brochure.pdf"} />
                    <VideoButton id={"Vwd7KUKRb2Xo"} />
                    <strong className="blue">Toner consumption and
                    improved print quality</strong><br />
                                        Navigator developed an improved surface which provides excellent
                                    printing quality. By improving toner adhesion and absorption, Navigator
                    maximises print results - more printed sheets with the same cartridge.

            </div>
            </div>
            <div className="row">
                <div className="col-md-3">
                    <ImgRender image={"24lb.jpg"} width={100} cssClass={"navigator-paper-img"} />
                    <h4 className="lb lb24">Platinum <strong>24lb</strong></h4>
                    <p><strong>Extra soft</strong> - microporous surface for
                    fast ink drying and precise absorption
for high definition images.</p>
                </div>
                <div className="col-md-3">
                    <ImgRender image={"28lb.jpg"} width={100} cssClass={"navigator-paper-img"} />
                    <h4 className=" lb lb28">Platinum <strong>28lb</strong></h4>
                    <p><strong>Superior thickness and smoothness</strong> -
                    Achieve a feeling of superior
                    quality, ideal to add value to your
communication.</p>
                </div>
                <div className="col-md-3">
                    <ImgRender image={"32lb.jpg"} width={100} cssClass={"navigator-paper-img"} />
                    <h4 className="lb lb32">Platinum <strong>32lb</strong></h4>
                    <p><strong>The best image definition</strong> - For
                    double-sided printing without
                    transparencies, even in color
applications.</p>
                </div>
                <div className="col-md-3">
                    <ImgRender image={"60lb.jpg"} width={100} cssClass={"navigator-paper-img"} />
                    <h4 className="lb lb60">Platinum <strong>60lb</strong></h4>
                    <p><strong>Excellence in digital color printing</strong> -
                    Perfect for image quality with high
contrast and definition</p>
                </div>
            </div>

            <div className="text-left" id="navgiator-relevant-details">
                <h2>Relevant Information:</h2>
            </div>
            <div className="row">
                <div className="col-md-6">
                    <div class="d-flex">
                        <div className="p4 align-self-start">
                            <ImgRender image={"bullet-star.svg"} cssClass={"svg-star"} normal={true} />
                        </div>
                        <div class="p4 align-self-end">Navigator is produced by an integrated mill from forest to paper.
                        </div>
                    </div>
                    <div class="d-flex">
                        <div className="p4 align-self-start">
                            <ImgRender image={"bullet-star.svg"} cssClass={"svg-star"} normal={true} />
                        </div>
                        <div class="p4 align-self-end">High quality fiber - by using the best quality fiber - Eucalyptus globulus
                        - Navigator guarantees optimum paper characteristics for excellent
                        printing results.
                        </div>
                    </div>
                    <div class="d-flex">
                        <div className="p4 align-self-start">
                            <ImgRender image={"bullet-star.svg"} cssClass={"svg-star"} normal={true} />
                        </div>
                        <div class="p4 align-self-end">The operating decision to always use the same raw material means
                        Navigator ensures the maximum level of quality and consistency of its
                        paper, each and every time.
                        </div>
                    </div>
                    <div class="d-flex">
                        <div className="p4 align-self-start">
                            <ImgRender image={"bullet-star.svg"} cssClass={"svg-star"} normal={true} />
                        </div>
                        <div class="p4 align-self-end">It’s smoother, more opaque and has an excellent thickness/stiffness
                        ratio, which allows for jam-free printing and a better printing quality,
                        even in duplex applications using colour.
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div class="d-flex">
                        <div className="p4 align-self-start">
                            <ImgRender image={"bullet-star.svg"} cssClass={"svg-star"} normal={true} />
                        </div>
                        <div class="p4 align-self-end">Environment – our responsible forest stewardship ensures the renewable
                        supply of Eucalyptus globulus fibre and the preservation of biodiversity.
                        </div>
                    </div>
                    <div class="d-flex">
                        <div className="p4 align-self-start">
                            <ImgRender image={"bullet-star.svg"} cssClass={"svg-star"} normal={true} />
                        </div>
                        <div class="p4 align-self-end">All the forests managed by The Navigator Company are certified
                        guaranteeing the origin of its raw material. Our main certification
                        systems are: FSC (Forest Stewardship Council), PEFC (Programme for the
                        Endorsement of Forest Certification Schemes). In addition, all of grupo
                        Portucel Soporcel’s mills are certified according to Ecolabel (European
                        Sustainability Measurement).
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default Navigator;